export const SET_COMMENTS = 'comments/SET_COMMENTS';
export const UPDATE_COMMENTS = 'comments/UPDATE_COMMENTS';
export const SET_COMMENT_TYPES = 'comments/SET_COMMENT_TYPES';
